"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
require("../Models");
const i0 = require("@angular/core");
class ViewGlossaryService {
    constructor(dataService) {
        this.dataService = dataService;
        this.getGlossaryWithSACodes = () => {
            return this.dataService.get("glossary/glossary-with-sa-codes");
        };
    }
}
exports.ViewGlossaryService = ViewGlossaryService;
ViewGlossaryService.ɵfac = function ViewGlossaryService_Factory(t) { return new (t || ViewGlossaryService)(i0.ɵɵinject('dataService')); };
ViewGlossaryService.ɵprov = i0.ɵɵdefineInjectable({ token: ViewGlossaryService, factory: ViewGlossaryService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ViewGlossaryService, [{
        type: core_1.Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['dataService']
            }] }]; }, null); })();
